import React from "react";
import styles from "./index.module.css";
import Button from "shared/Button";
import TextInput from "shared/@forms/TextInput";
import Select from "shared/@forms/Select";
import TextArea from "shared/@forms/TextArea";
import { useAddGracePeriod } from "./useAddGracePeriod";
import { useAwards } from "./../../External/useAwards";

const AddGracePeriod = (onClose) => {
  const {
    iboNumber,
    setIboNumber,

    graceAward,
    setGraceAward,

    newAward,
    setNewAward,

    periodStart,
    setPeriodStart,

    periodEnd,
    setPeriodEnd,

    notes,
    setNotes,

    submit,
  } = useAddGracePeriod(onClose);

  const { awards, loading, isWaiting } = useAwards();

  return (
    <>
      <form style={{ width: "500px" }}>
        <div>
          <h3>Ibo Number</h3>
          <TextInput
            value={iboNumber}
            onChange={(e) => {
              setIboNumber(e.target.value);
            }}
          />
        </div>

        <div className={styles.doubleInputRow}>
          <div>
            <h3>Grace Award</h3>
            <Select
              onChange={(e) => {
                setGraceAward(e.target.value - 1);
              }}
            >
              {awards ? (
                awards.map((a, i) => {
                  return (
                    <option key={i} value={a.id}>
                      {a.wwgDesc}
                    </option>
                  );
                })
              ) : (
                <option>Loading...</option>
              )}
            </Select>
          </div>

          <div>
            <h3>New Award</h3>
            <Select
              onChange={(e) => {
                setNewAward(e.target.value - 1);
              }}
            >
              {awards ? (
                awards.map((a, i) => {
                  return (
                    <option key={i} value={a.id}>
                      {a.wwgDesc}
                    </option>
                  );
                })
              ) : (
                <option>Loading...</option>
              )}
            </Select>
          </div>
        </div>

        <div className={styles.doubleInputRow}>
          <div>
            <h3>Period Start</h3>
            <TextInput
              className={styles.modalTextInput}
              value={periodStart}
              onChange={(e) => {
                setPeriodStart(e.target.value);
              }}
            />
          </div>

          <div>
            <h3>Period End</h3>
            <TextInput
              className={styles.modalTextInput}
              value={periodEnd}
              onChange={(e) => {
                setPeriodEnd(e.target.value);
              }}
            />
          </div>
        </div>

        <div className={styles.padding}>
          <h3>Notes</h3>
          <TextArea
            value={notes}
            onChange={(e) => {
              setNotes(e.target.value);
            }}
          />
        </div>

        <div className={styles.buttonRow}>
          <Button className={styles.cancelButton} onClick={onClose}>
            Cancel
          </Button>
          <Button
            className={styles.addButton}
            onClick={(e) => {
              e.preventDefault();
              submit();
            }}
          >
            Add Grace Period
          </Button>
        </div>
      </form>
    </>
  );
};
export default AddGracePeriod;
